module.exports = __webpack_public_path__ + "media/images/lazy-placeholder-3ad0406b32a391a887963d883ef5534c.jpg";